import { AB_TESTING_SUPPORTED_PAGE_TYPES } from '../constants';
import { fetchPlatformGemX, isConnectedGemX } from '../stores/gemX';

import getParameterByName from '@/app/utils/getParameterByName';

export const useABTestingState = () => {
  fetchPlatformGemX();

  const editingPageType = computed(() => getParameterByName('type'));
  const isEnableFeatureGemX = computed(() => isConnectedGemX.value);
  const isShowABTestingPanel = computed(() => !!isShowABTestingSideBar.value);
  const isShowABTestingSideBar = computed(() => {
    const isPageTypeSupported = AB_TESTING_SUPPORTED_PAGE_TYPES.includes(editingPageType.value || '');
    return isPageTypeSupported && isEnableFeatureGemX.value;
  });

  return {
    isShowABTestingPanel,
    isShowABTestingSideBar,
  };
};
